<div class="wrapper">
  <div class="content">
    <mat-card>
      <mat-card-header>
        <mat-card-header></mat-card-header>
        <mat-icon svgIcon="close"
          class="close-x"
        (click)="removeComponent()"></mat-icon>
      </mat-card-header>
      @if (!content) {
        <div>
          <mat-spinner color="accent"></mat-spinner>
        </div>
      }
      @if (content) {
        <mat-card-content>
          <div class="additional-info-items-layer-content"
            [innerHTML]="content | safeHtml">
          </div>
        </mat-card-content>
      }
      <mat-card-actions>
        <button mat-raised-button
          size="small"
          color="primary"
          (click)="removeComponent()"
          translate
          >
          i18n.button.close
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
